var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"normal-region"},[_c('div',{staticClass:"region-title",on:{"click":_vm.onDetailClick}},[_vm._v(_vm._s(_vm.info.region))]),_c('div',{staticClass:"yeji-box",on:{"click":_vm.toShopPage}},[_c('popover',{staticClass:"item",attrs:{"placement":"top-start"}},[_c('diamonds-popover',{attrs:{"slot":"content"},slot:"content"}),_c('sales-card',{attrs:{"title":"钻石业绩","background":"#fff","info":{
          count: _vm.info.zs,
          hb: _vm.info.zshb,
          tb: _vm.info.zstb,
          dbl: _vm.info.zsdb,
        }}},[_vm._v(_vm._s(_vm.regFenToYuan(_vm.info.zs)))])],1),_c('sales-card',{staticClass:"item",attrs:{"title":"非素业绩","background":"#fff","info":{
        count: _vm.info.fs,
        hb: _vm.info.fshb,
        tb: _vm.info.fstb,
        dbl: _vm.info.fsdb,
      }}}),_c('sales-card',{staticClass:"item",attrs:{"title":"素金销售","background":"#fff","info":{
        count: _vm.info.sj,
        hb: _vm.info.sjhb,
        tb: _vm.info.sjtb,
        dbl: _vm.info.sjdb,
      }}}),_c('img',{staticClass:"icon-arrow",attrs:{"src":require("assets/operate/arrow.png"),"alt":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }